import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../../../components/toast/Toast';
import { useUpdateFirmAdmin } from '../../../../queries/use-update-firm-admin';

type ChangeFirmAdminConfirmDialogProps = {
    userId: string;
    onClose: () => void;
};

function ChangeFirmAdminConfirmDialog({ userId, onClose }: ChangeFirmAdminConfirmDialogProps): JSX.Element {
    const updateFirmAdminQuery = useUpdateFirmAdmin();

    function updateAdmin(): void {
        updateFirmAdminQuery.mutate(
            { userId },
            {
                onSuccess: () => {
                    onClose();
                    toastNotification('success', 'Firm admin updated!');
                },
            }
        );
    }

    return (
        <Dialog
            description="Do you want to change the firm admin? You will lose admin privileges immediately. Please inform the new admin to go to firm settings to update any relevant billing information."
            onClose={onClose}
            onPrimaryActionClick={updateAdmin}
            onSecondaryActionClick={onClose}
            isOpen
            primaryAction="Update"
            secondaryAction="Cancel"
            title="Change Firm Admin"
            type="info"
            isLoading={updateFirmAdminQuery.isLoading}
        />
    );
}

export default ChangeFirmAdminConfirmDialog;
